import React from "react";
import { useParams } from "react-router-dom";
import GetOrderDetailsHook from "../../hook/admin/GetOrderDetailsHook";
import { useTranslation } from "react-i18next";
import { Container, Table } from "react-bootstrap";
import Cookies from "js-cookie";
import LoadingSpinner from "../Utilities/LoadingSpinner";
import "./InvoicePage.css"; // We will create this

const InvoicePage = () => {
  const { id } = useParams();
  const [orderData, cartItems, settingsRes, ref, setLoading, loading] = GetOrderDetailsHook(id);
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!orderData) {
    return <div className="text-center mt-5">Order not found</div>;
  }

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="invoice-wrapper">
      <Container className="invoice-container">
        {/* Action Bar - Hidden on Print */}
        <div className="invoice-action-bar d-print-none mb-4 d-flex justify-content-between align-items-center">
          <h4>{t("Invoice")}</h4>
          <button className="btn btn-primary" onClick={handlePrint}>
            <i className="fa-solid fa-print me-2"></i> طباعة الفاتورة (PDF)
          </button>
        </div>

        {/* Invoice Paper */}
        <div className="invoice-paper">
          {/* Header */}
          <div className="invoice-header">
            <div className="company-details">
              <h2>{Cookies.get("i18next") === "ar" ? settingsRes?.data?.titleAr : settingsRes?.data?.titleEn || "MegaStore"}</h2>
              <p className="text-muted mb-0">فاتورة طلب مشتريات</p>
            </div>
            <div className="invoice-title-section text-end">
              <h1 className="invoice-title">INVOICE</h1>
              <p className="mb-0"><strong>رقم الطلب:</strong> #{orderData.orderNumber}</p>
              <p className="mb-0"><strong>التاريخ:</strong> {formatDate(orderData.createdAt)}</p>
            </div>
          </div>

          <hr className="invoice-divider" />

          {/* Billing Info */}
          <div className="invoice-billing-row row mb-4">
            <div className="col-6">
              <h6 className="billing-title text-muted">إلى العميل:</h6>
              <h5>{orderData.user?.firstname} {orderData.user?.lastname}</h5>
              <p className="mb-0"><i className="fa-solid fa-phone me-2 text-muted"></i>{orderData.user?.mobile}</p>
              <p className="mb-0"><i className="fa-solid fa-envelope me-2 text-muted"></i>{orderData.user?.email}</p>
            </div>
            <div className="col-6 text-end">
              <h6 className="billing-title text-muted">عنوان الشحن:</h6>
              <p className="mb-0">{orderData.userAddress?.address}</p>
              {orderData.userAddress?.zone && <p className="mb-0">{orderData.userAddress?.zone}</p>}
              {orderData.userAddress?.mobile && <p className="mb-0">Tel: {orderData.userAddress?.mobile}</p>}
            </div>
          </div>

          {/* Order Details Info */}
          <div className="invoice-info-bar mb-4">
            <div className="info-box">
              <span className="info-label">حالة الطلب</span>
              <span className="info-value">{orderData.orderStatusId?.nameAr || "قيد التنفيذ"}</span>
            </div>
            <div className="info-box">
              <span className="info-label">حالة الدفع</span>
              <span className="info-value">{orderData.isPaid ? "مدفوع" : "غير مدفوع"}</span>
            </div>
            <div className="info-box">
              <span className="info-label">طريقة الدفع</span>
              <span className="info-value">{orderData.paymentMethodId?.nameAr || "غير محدد"}</span>
            </div>
          </div>

          {/* Items Table */}
          <Table bordered hover responsive className="invoice-table mb-4">
            <thead>
              <tr>
                <th>#</th>
                <th>المنتج</th>
                <th>التصنيف</th>
                <th className="text-center">الكمية</th>
                <th className="text-end">السعر الإجمالي</th>
              </tr>
            </thead>
            <tbody>
              {orderData.orderItems?.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>
                    <strong>{item.product?.nameAr}</strong>
                    {item.productNotes && <div className="text-muted small mt-1">ملاحظة: {item.productNotes}</div>}
                  </td>
                  <td>
                     {item?.variant?.title?.includes("__::SEPARATOR::__")
                        ? (Cookies.get("i18next") === "ar" ? item?.variant?.title?.split("__::SEPARATOR::__")[1] : item?.variant?.title?.split("__::SEPARATOR::__")[0])
                        : (item?.variant?.title || "-")}
                  </td>
                  <td className="text-center">{item.quantity}</td>
                  <td className="text-end fw-bold">{item.price} {Cookies.get("i18next") === "ar" ? settingsRes?.data?.defaultCurrancy?.ar : settingsRes?.data?.defaultCurrancy?.en}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Totals */}
          <div className="invoice-totals row justify-content-end">
            <div className="col-md-5 col-12">
              <Table borderless size="sm">
                <tbody>
                  <tr>
                    <td>المجموع الفرعي:</td>
                    <td className="text-end">{orderData.totalPrice} {Cookies.get("i18next") === "ar" ? settingsRes?.data?.defaultCurrancy?.ar : settingsRes?.data?.defaultCurrancy?.en}</td>
                  </tr>
                  {orderData.taxPrice > 0 && (
                    <tr>
                      <td>الضريبة:</td>
                      <td className="text-end">{orderData.taxPrice}</td>
                    </tr>
                  )}
                  {orderData.shippingPrice > 0 && (
                    <tr>
                      <td>الشحن:</td>
                      <td className="text-end">{orderData.shippingPrice}</td>
                    </tr>
                  )}
                  <tr className="invoice-total-row">
                    <td><strong>الإجمالي الكلي:</strong></td>
                    <td className="text-end"><strong>{orderData.totalPrice} {Cookies.get("i18next") === "ar" ? settingsRes?.data?.defaultCurrancy?.ar : settingsRes?.data?.defaultCurrancy?.en}</strong></td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
          
          <div className="invoice-footer mt-5 text-center text-muted">
            <p>شكراً لتسوقكم معنا!</p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default InvoicePage;
